// A dropdown of uploaded audio-library files, used wherever a sound file path is stored
// (IVR prompts, queue music/announcement, broadcast audio, inbound-route PLAYBACK destination).
// A value that is not a library file (a FreeSWITCH sound path, local_stream://moh, tone_stream://...,
// as the seed data and older rows use) stays selectable, and "Other path…" allows typing one.
import * as React from 'react';
import { Input, Select } from '@/components/ui/input';
import { useRefOptions } from '@/hooks/meta';
import { t } from '@/i18n';
import { enumLabel } from '@/lib/utils';

const CUSTOM = '__custom__';

export function AudioFilePicker({ name, value, onChange, category, required }: {
  name?: string; value: string | null | undefined; onChange: (v: string | null) => void; category?: string; required?: boolean;
}) {
  const files = useRefOptions('audio-files');
  // translations are not picked: the engine plays the caller's language of the chosen file by itself (PHASE26)
  const rows = (files.data ?? []).filter((f) => (!category || f.category === category) && !f.base_file_id);
  const inLibrary = !!value && rows.some((f) => f.file_path === value);
  const [typing, setTyping] = React.useState(false);
  if (typing) {
    return (
      <div className="flex gap-1">
        <Input name={name} autoFocus placeholder="/path/file.wav, local_stream://moh, tone_stream://…" value={value ?? ''}
          onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)} />
        <button type="button" className="text-xs text-muted-foreground underline" onClick={() => setTyping(false)}>{t('library')}</button>
      </div>
    );
  }
  return (
    <Select name={name} value={value ?? ''} onChange={(e) => { if (e.target.value === CUSTOM) setTyping(true); else onChange(e.target.value || null); }}>
      <option value="">{required ? t('Choose a file…') : t('(none)')}</option>
      {value && !inLibrary && <option value={value}>{value}</option>}
      {rows.map((f) => <option key={f.id} value={f.file_path}>{f.name} ({enumLabel(f.category)}{f.language ? `, ${f.language}` : ''})</option>)}
      <option value={CUSTOM}>{t('Other path…')}</option>
    </Select>
  );
}
